import React from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

const AuthenticatedRedirect = ({ children }) => {
  const { isAuthenticated } = useAuth0();
  const hasPasswordlessToken = !!localStorage.getItem("vibeu_access_token");
  if (isAuthenticated || hasPasswordlessToken) {
    return <Navigate to="/post-login" />;
  }

  return children;
};

AuthenticatedRedirect.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthenticatedRedirect;
